import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className = "", y = 30, once = true }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount: 0.15 }}
            transition={{ duration: 0.75, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function SectionHeading({ eyebrow, title, sub, light = false, align = "center" }) {
    const alignCls = align === "left" ? "text-left items-start" : "text-center items-center mx-auto";
    return (
        <div className={`flex max-w-2xl flex-col ${alignCls}`}>
            <Reveal>
                <span
                    className={`inline-flex items-center gap-2 font-mono text-[11px] font-bold uppercase tracking-[0.22em] ${
                        light ? "text-telegram-glow" : "text-telegram-deep"
                    }`}
                >
                    <span className={`h-px w-6 ${light ? "bg-telegram-glow" : "bg-telegram-deep"}`} />
                    {eyebrow}
                </span>
            </Reveal>
            <Reveal delay={0.08}>
                <h2
                    className={`mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight sm:text-4xl lg:text-[2.75rem] ${
                        light ? "text-white" : "text-ink"
                    }`}
                >
                    {title}
                </h2>
            </Reveal>
            {sub && (
                <Reveal delay={0.16}>
                    <p className={`mt-5 text-base leading-relaxed sm:text-lg ${light ? "text-white/70" : "text-slate-500"}`}>
                        {sub}
                    </p>
                </Reveal>
            )}
        </div>
    );
}

export default Reveal;
